module.exports = __webpack_public_path__ + "static/media/right-reset-password-719275.29e62d1d.png";